import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const navLinks = [
    { id: 1, labelKey: 'header.home', href: '/' },
    { id: 2, labelKey: 'header.about', href: '/hakkimizda' },
    { id: 3, labelKey: 'header.purpose', href: '/amac' },
    { id: 4, labelKey: 'header.trainings', href: '/egitimler' },
    { id: 5, labelKey: 'header.projects', href: '/projeler' },
    { id: 6, labelKey: 'header.events', href: '/etkinlikler' },
  ];

  const handleNavClick = (href) => {
    navigate(href);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="relative bg-[#030711] border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_cyberyouth/artifacts/z6i2gnpf_1-Photoroom.png" 
                alt="Cyber Logo" 
                className="h-10 w-auto"
              />
              <span className="text-white font-semibold text-lg">Cyber</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links - Two columns */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => handleNavClick(link.href)}
                  className="text-gray-500 hover:text-[#4DFF88] text-sm transition-colors duration-300 text-left"
                >
                  {t(link.labelKey)}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#4DFF88]" />
                <a
                  href="mailto:csresearcheryouth@gmail.com"
                  className="text-gray-500 hover:text-white text-sm transition-colors"
                >
                  csresearcheryouth@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#4DD6FF]" />
                <span className="text-gray-500 text-sm">Zonguldak / Türkiye</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <p className="text-gray-600 text-sm text-center">
              © {new Date().getFullYear()} Siber Güvenlik Araştırmacıları ve Gençlik Derneği. {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
